import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GateHausLogo from '../components/GateHausLogo';
import { useAuth } from '../context/AuthContext';

const POST_LOGIN_REDIRECT_KEY = 'gate.haus.post_login_redirect';

const OAuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeLogin } = useAuth();
  const [status, setStatus] = useState('Completing sign-in…');
  const [error, setError] = useState<string | null>(null);

  const params = useMemo(() => {
    return {
      code: searchParams.get('code'),
      state: searchParams.get('state') || undefined,
      error: searchParams.get('error')
    };
  }, [searchParams]);

  useEffect(() => {
    const finishAuth = async () => {
      if (params.error) {
        setError('Sign-in was cancelled. Please try again.');
        return;
      }

      if (!params.code) {
        setError('Missing authorization code. Please restart the login flow.');
        return;
      }

      try {
        await completeLogin({ code: params.code, state: params.state });
        const redirect = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY) || '/dashboard';
        sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
        navigate(redirect, { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unable to complete sign-in.');
      } finally {
        setStatus('Completing sign-in…');
      }
    };

    finishAuth();
  }, [completeLogin, navigate, params]);

  return (
    <div className="full-centre">
      <div className="card" style={{ width: '360px' }}>
        <GateHausLogo stacked size={44} />
        <h2>Signing you in</h2>
        <p style={{ color: 'var(--gray)' }}>{status}</p>
        {error && (
          <p style={{ color: 'var(--danger)' }} role="alert">
            {error}
          </p>
        )}
        {error && (
          <button className="primary-button" onClick={() => navigate('/login')}>
            Back to login
          </button>
        )}
      </div>
    </div>
  );
};

export default OAuthCallbackPage;
